module.exports = __webpack_public_path__ + "static/media/S1N7-4.463fbd1f.svg";